import * as React from "react";
import classnames from "classnames";
import { MediaQuery } from "@grandvisionhq/common";
import { StepForm } from "@grandvisionhq/configurator";
import { useIntl } from "@grandvisionhq/state";
import { Upload } from "@grandvisionhq/upload";
import "../../../../../../../../state/state/actions.js";
import { PD_SCOPE, RX_SCOPE, PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID } from "../../../../../../../../state/state/constants.js";
import "../../../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../../../state/bundles/state/bundles/reducer.js";
import "../../../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../../../state/products/state/products/selectors.js";
import "../../../../../../../../state/products/state/products/reducer.js";
/* empty css                            */
const PrescriptionUploadForm = ({
  className,
  onSubmit,
  onStatusChange,
  uploadState,
  showPdUpload = true,
  ...rest
}) => {
  const { getLabel } = useIntl();
  const isOnDesktop = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
  const uploadLayout = isOnDesktop ? "vertical" : "horizontal";
  const handlePDStatusChange = React.useCallback(
    (status) => onStatusChange(status, PD_SCOPE),
    [onStatusChange]
  );
  const handleRXStatusChange = React.useCallback(
    (status) => onStatusChange(status, RX_SCOPE),
    [onStatusChange]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    StepForm,
    {
      className: classnames("prescription-upload-form", className, {
        "prescription-upload-form--one-column": !showPdUpload,
        "prescription-upload-form--two-columns": showPdUpload
      }),
      "data-t": rest["data-t"],
      onSubmit
    },
    /* @__PURE__ */ React.createElement(
      Upload,
      {
        variant: uploadLayout,
        id: "rx-upload",
        "data-t": "rx-upload",
        iconName: "upload-prescription",
        title: getLabel("products.glasses.upload.rx.title"),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handleRXStatusChange,
        uploadStatus: uploadState[RX_SCOPE] ?? { status: "IDLE" },
        referenceId: RX_SCOPE,
        scope: RX_SCOPE,
        className: "prescription-upload-form__uploader"
      }
    ),
    showPdUpload && /* @__PURE__ */ React.createElement(
      Upload,
      {
        variant: uploadLayout,
        id: "pd-upload",
        "data-t": "pd-upload",
        iconName: "upload-pd",
        title: getLabel("products.glasses.upload.pd.title"),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handlePDStatusChange,
        uploadStatus: uploadState[PD_SCOPE] ?? { status: "IDLE" },
        referenceId: PD_SCOPE,
        scope: PD_SCOPE,
        className: "prescription-upload-form__uploader"
      }
    )
  ));
};
export {
  PrescriptionUploadForm
};
//# sourceMappingURL=PrescriptionUploadForm.js.map
